(ns frontend.ui.page.lp-report-editor.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.lp-portal.lp-report :as lp-report]
   [common.util :as cu]
   [frontend.ui.component.heading.view :refer [h1]]
   [frontend.ui.component.steps-band.view :refer [steps-band]]
   [frontend.ui.page.lp-report-editor.common.view :refer [continue-button]]
   [frontend.ui.page.lp-report-editor.event :as event]
   [frontend.ui.page.lp-report-editor.step-1-initialization.view :as initialization]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.view :as data-gathering]
   [frontend.ui.page.lp-report-editor.step-3-review.view :as review]
   [frontend.ui.page.lp-report-editor.step-4-pending-approval.view :as pending-approval]
   [frontend.ui.page.lp-report-editor.step-5-approved.view :as approved]
   [frontend.ui.page.lp-report-editor.step-6-publishing-queue.view :as publishing-queue]
   [frontend.ui.page.lp-report-editor.step-7-published.view :as published]
   [frontend.ui.page.lp-report-editor.step-8-archived.view :as archived]
   [frontend.ui.page.lp-report-editor.style :as style]
   [frontend.ui.page.lp-report-editor.sub :as sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]))

(def report-steps
  (->> lp-report/report-status-options
       (cu/remove-by :key :lp-report.step/archived)
       (map (fn [opt]
              {:title    (:label opt)
               :icon-id  (:icon-id opt)
               :step-key (:key opt)}))))
(defn- head
  [active-step-kw]
  (let [lp-report @(rf/subscribe [::sub/lp-report])
        fund @(rf/subscribe [::sub/fund])
        {:keys [lp-report/title lp-report/step]} lp-report]
    [:div
     {:class (<class style/header)}
     [:div
      [h1 (str (:fund/name fund) " - " title)]]
     [steps-band
      {:active-step-key    active-step-kw
       :activate-step      (fn [idx]
                             (rf/dispatch [::event/activate-step idx]))
       :completed-step-key (if (= step :lp-report.step/archived)
                             :lp-report.step/published
                             step)}
      report-steps]]))

(defn editor-view
  "Ids for data must be strings and not keywords (because they are dealt with as
   such in HTML so this prevents going back and forth between keyword/string."
  [report-id]
  (let [initialized? @(rf/subscribe [::sub/initialized?])
        active-step @(rf/subscribe [::sub/active-step])
        any-access? @(rf/subscribe [::sub/has-access?])
        fund-ui-data @(rf/subscribe [::sub/fund-report-ui-data report-id])
        feeder-id (:db/id (first @(rf/subscribe [::sub/feeder-reports])))
        feeder-ui-data @(rf/subscribe [::sub/feeder-report-ui-data feeder-id])
        holdings @(rf/subscribe [::sub/lp-report-holdings])
        ui-data-by-holding (->> holdings
                                (keep (fn [holding]
                                        (let [template (:lp-report-holding/template-type (second holding))
                                              no-reporting? (= template :lp-report-holding-template/no-reporting)
                                              holding-id (first holding)
                                              ui-data (rf/subscribe [::sub/holding-report-ui-data
                                                                     holding-id])]
                                          (when-not no-reporting? [holding-id @ui-data]))))
                                (into {}))]
    (if-not initialized?
      [:div
       {:class (<class style/page-container-loading)}
       [:img
        {:src   "/img/Spinning-arrow.gif"
         :class (<class style/img)}]

       [:span "Loading"]]
      [:div.lpreporting

       {:class (<class style/page-container)}
       [:<>
        [:div
         {:id    "highcharts"
          :style {:display :none}}]
        (if-not any-access?
          [:<>
           [:div
            {:class (<class style/no-data)}
            [:img.img-fluid.max-width {:src "/img/undraw_No_data_re_kwbl.svg"}]
            [:strong
             (loc/tr :lp-report-cannot-access)]
            [:div
             [continue-button]]]]
          [:<>
           [head active-step]
           (case active-step
             :lp-report.step/initialization [initialization/body]
             :lp-report.step/data-gathering [data-gathering/body
                                             {:report-id          report-id
                                              :fund-ui-data       fund-ui-data
                                              :feeder-ui-data     feeder-ui-data
                                              :ui-data-by-holding ui-data-by-holding}]
             :lp-report.step/review [review/body]
             :lp-report.step/pending-approval [pending-approval/body]
             :lp-report.step/approved [approved/body]
             :lp-report.step/publishing-queue [publishing-queue/body]
             :lp-report.step/published [published/body]
             :lp-report.step/archived [archived/body]
             [:div "Unknown step " active-step])])]])))
